// Small display helpers.
import type { Script } from '../types';

export function duration(sec: number): string {
  if (!sec) return '';
  const m = Math.floor(sec / 60), s = sec % 60;
  return m ? `${m} m${s ? ` ${s} s` : ''}` : `${s} s`;
}

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/** "12 Oct" from an ISO date/time (date part only, so time zones can't shift the day). */
export function shortDate(iso: string | null | undefined): string {
  if (!iso) return '';
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
  if (!m) return '';
  return `${Number(m[3])} ${MONTHS[Number(m[2]) - 1]}`;
}

export function localDay(d = new Date()): string {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

export function noteDate(iso: string): string {
  const created = new Date(iso);
  return localDay(created) === localDay() ? 'TODAY' : shortDate(localDay(created)).toUpperCase();
}

export interface Names { ta?: string; en?: string; tg?: string }

/** Primary and secondary names for a chosen script, falling back when a script is missing. */
export function namesFor(n: Names, script: Script): [string, string] {
  // One name in the reader's script (falling back to the others when missing). The second value
  // stays for callers' shape but is always empty: the app never shows a name in two languages.
  const order: Record<Script, (keyof Names)[]> = { ta: ['ta', 'en', 'tg'], en: ['en', 'tg', 'ta'], tg: ['tg', 'en', 'ta'] };
  const primary = order[script].map((k) => n[k]?.trim() || '').find(Boolean) || 'Untitled recipe';
  return [primary, ''];
}

export function isInstagramURL(url: string): boolean {
  try {
    return /(^|\.)instagram\.com$/.test(new URL(url).hostname);
  } catch {
    return false;
  }
}

export const VERDICT_LABEL: Record<string, string> = { again: 'Make again', ok: 'It was okay', no: 'Not for us' };
